import { useIntl } from 'react-intl';

import { getTaxMessageShort } from '@/lib/regions';
import { useRegionProvider } from '@/providers/RegionProvider';

import * as S from './SalesTaxBadge.styles';

interface SalesTaxBadgeProps {
  channel?: string;
  disabled?: boolean;
}
export const SalesTaxBadge = ({
  channel,
  disabled = false,
}: SalesTaxBadgeProps) => {
  const { formatMessage } = useIntl();

  let taxMessage;
  const {
    country: { channelSlug: channelByLocale },
  } = useRegionProvider();

  if (channel !== undefined) {
    taxMessage = getTaxMessageShort(channel);
  } else {
    taxMessage = getTaxMessageShort(channelByLocale);
  }
  return (
    <S.TaxText data-test-id='SalesTaxBadgeTaxText' disabled={disabled}>
      {taxMessage && formatMessage(taxMessage)}
    </S.TaxText>
  );
};

SalesTaxBadge.displayName = 'SalesTaxBadge';
